import { OrderView } from '../../../../orders/order';
import { FormDropdown } from '@ami/react/core';
import { FormFileUpload } from '@ami/react/core';
import { FormInput } from '@ami/react/core';
import CustomOrderDocument from '../../../../documents/customOrderDocument';
import PropTypes from 'prop-types';
import React from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { HistoricalTechDocTypes } from '../../../../historical-tech-docs/historicalTechDocTypes';

const CustomDocumentData = ({
  customDocument,
  customDocumentChanged,
  shippableLineItems,
}) => {
  const { name, fileName } = customDocument;
  const updateCustomDocument = (updateObject) =>
    customDocumentChanged(
      new CustomOrderDocument({ ...customDocument, ...updateObject })
    );
  const documentLineItem = shippableLineItems.find(
    (x) => x.id === customDocument.lineItemId
  );
  return (
    <div className="order-document-form">
      <div>
        <div>
          <FormDropdown
            placeholder="Type"
            label="Type"
            items={HistoricalTechDocTypes.map((x) => ({ id: x, label: x }))}
            selectedId={
              customDocument.isOtherType ? 'Other' : customDocument.name
            }
            onChange={(name) =>
              name === 'Other'
                ? updateCustomDocument({ isOtherType: true, name: '' })
                : updateCustomDocument({ isOtherType: false, name })
            }
          />
        </div>
      </div>
      {customDocument.isOtherType && (
        <div className="row">
          <div className="col">
            <FormInput
              id="name"
              label="Name"
              value={name}
              onChange={(e) => updateCustomDocument({ name: e.target.value })}
            />
          </div>
        </div>
      )}
      <div className="row">
        <div className="col">
          <FormFileUpload
            label="File"
            hideUploadAfterFile={true}
            onFileUploaded={(fileInfo) =>
              updateCustomDocument({
                fileKey: fileInfo.key,
                fileName: fileInfo.name,
              })
            }
          >
            {fileName}
          </FormFileUpload>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormDropdown
            placeholder="None"
            isClearable={true}
            label="Associated line item (optional)"
            items={shippableLineItems.map((x) => ({
              id: x.id,
              label: `${x.partNumber} - ${x.name}`,
            }))}
            selectedId={customDocument.lineItemId}
            onChange={(lineItemId) =>
              updateCustomDocument({
                lineItemId,
                serialNumbers: lineItemId
                  ? shippableLineItems.find((x) => x.id === lineItemId)
                      .serialNumbers
                  : [],
              })
            }
          />
        </div>
      </div>
      {documentLineItem && (
        <div className="row">
          <div className="col">
            <FormGroup>
              <Label className="form-label">Associated Serial Numbers</Label>
              {documentLineItem.serialNumbers.map((serialNumber) => (
                <div key={serialNumber}>
                  <Input
                    type="checkbox"
                    id={serialNumber}
                    checked={customDocument.serialNumbers.includes(
                      serialNumber
                    )}
                    onChange={(e) => {
                      if (e.target.checked) {
                        updateCustomDocument({
                          serialNumbers:
                            customDocument.serialNumbers.concat(serialNumber),
                        });
                      } else {
                        updateCustomDocument({
                          serialNumbers: customDocument.serialNumbers.filter(
                            (x) => x !== serialNumber
                          ),
                        });
                      }
                    }}
                  />
                  <Label for={serialNumber}>
                    {serialNumber} - {documentLineItem.name}
                  </Label>
                </div>
              ))}
            </FormGroup>
          </div>
        </div>
      )}
    </div>
  );
};

const AddCustomDocumentForm = ({
  order,
  customDocument,
  customDocumentChanged,
}) => {
  return (
    <Form>
      <CustomDocumentData
        shippableLineItems={order.lineItems.filter((x) => x.shipmentId >= 0)}
        customDocument={customDocument}
        customDocumentChanged={customDocumentChanged}
      />
    </Form>
  );
};

AddCustomDocumentForm.propTypes = {
  order: PropTypes.instanceOf(OrderView).isRequired,
  customDocument: PropTypes.instanceOf(CustomOrderDocument).isRequired,
  customDocumentChanged: PropTypes.func.isRequired,
};

export default AddCustomDocumentForm;
